import React, { useState, useEffect } from 'react';
import { Table, Badge, Button } from 'react-bootstrap';
import { FaHistory, FaDownload } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import StudentService from '../../services/studentService';
import { toast } from 'react-toastify';
import StudentReceiptView from './StudentReceiptView';
import Header from '../../components/common/Header';

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    loadTransactions();
  }, []);

  const loadTransactions = async () => {
    try {
      setLoading(true);
      const response = await StudentService.getStudentTransactions(user.id);
      setTransactions(response.data || []);
    } catch (error) {
      toast.error('Failed to load transactions');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewReceipt = (transaction) => {
    setSelectedTransaction(transaction);
    setShowReceiptModal(true);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(amount || 0);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  if (loading) {
    return (
      <div>
        <Header />
        <div className="container-fluid p-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (transactions.length === 0) {
    return (
      <div>
        <Header />
        <div className="container-fluid p-5 text-center">
          <FaHistory size={50} className="text-muted mb-3" />
          <h5>No transactions yet</h5>
          <p className="text-muted">Your payment history will appear here</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container-fluid p-4">
        <h2 className="mb-4">Transaction History</h2>
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>Receipt No</th>
              <th>Date</th>
              <th>Course</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((t) => (
              <tr key={t.id}>
                <td>
                  <code>{t.receipt_number}</code>
                </td>
                <td>{formatDate(t.payment_date)}</td>
                <td>{t.course_name}</td>
                <td className="fw-bold text-success">{formatCurrency(t.amount)}</td>
                <td>
                  <Badge bg="secondary" className="text-uppercase">
                    {t.payment_method}
                  </Badge>
                </td>
                <td>
                  <Badge bg="success">Completed</Badge>
                </td>
                <td>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleViewReceipt(t)}
                  >
                    <FaDownload className="me-1" /> Receipt
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <StudentReceiptView
          show={showReceiptModal}
          onHide={() => {
            setShowReceiptModal(false);
            setSelectedTransaction(null);
          }}
          transaction={selectedTransaction}
        />
      </div>
    </div>
  );
};

export default TransactionHistory;